import React from 'react'
import styled from 'styled-components'

import { cssProps } from '../../../../common/utils/cssProps'
import { getStyles } from '../../utils'

const StyledDiv = styled.div`
    ${getStyles()}
`

export const Style = ({ ...props }) => {
    const { style, other } = Object.keys(props).reduce(
        (acc, key) => {
            if (cssProps[key]) {
                acc.style[key] = props[key]
            } else {
                acc.other[key] = props[key]
            }
            return acc
        },
        {
            style: {},
            other: {},
        },
    )

    return (
        <StyledDiv
            {...props}
            style={style}
        />
    )
}
